module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Level/images/level-bg.5b58c8fc.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Level/images/level-bg.png
// module id = 2518
// module chunks = 11